/* =========================================================================
   BekateqVariants — zentrale Varianten-Logik (Sortierung + Upsell-Dropdown)
   =========================================================================
   Eine Quelle der Wahrheit für:
   - parseSize():      "10 l", "2,5kg", "6 x 500 ml", "3x 750g" → normierter
                       Zahlenwert (Liter- bzw. Kilo-Äquivalent)
   - sortVariants():   Varianten numerisch aufsteigend (1 l vor 10 l),
                       unabhängig von der Reihenfolge im Shopify-Backend
   - smallestAvailable(): kleinste verfügbare Variante als Vorauswahl
   - buildSelect():    kompaktes <select> für Upsell-Kacheln
   - sortPillGroups(): sortiert die Mengen-Pills im PDP-Variant-Picker
   Verwendet von: product-cross-sell, pre-checkout-upsell, PDP-Addons,
   Projektberater-Zubehör, PDP-Variant-Picker (Datenblatt-Template).
   ========================================================================= */
(function () {
  'use strict';

  /* N×M-Multipack: "6 x 500 ml", "6x500ml", "3 × 2,5 kg" */
  var MULTI_RE = /(\d+)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*(kg|g|l|liter|ltr|ml|m²|m2|qm)\b/i;
  /* Einzelgröße: "10 l", "2,5kg", "750 g", "100ml", "5 m²" */
  var SINGLE_RE = /(\d+(?:[.,]\d+)?)\s*(kg|g|l|liter|ltr|ml|m²|m2|qm)\b/i;

  /* Einheit → Faktor auf Basiseinheit (kg bzw. l; qm eigener Raum) */
  function unitFactor(unit) {
    switch (unit.toLowerCase()) {
      case 'kg': return 1;
      case 'g': return 0.001;
      case 'l': case 'liter': case 'ltr': return 1;
      case 'ml': return 0.001;
      case 'm²': case 'm2': case 'qm': return 1;
      default: return 1;
    }
  }

  function toNum(s) {
    return parseFloat(String(s).replace(',', '.'));
  }

  /* Titel → normierter Größenwert oder null, wenn nichts erkennbar */
  function parseSize(title) {
    if (!title) return null;
    var str = String(title);
    var m = str.match(MULTI_RE);
    if (m) {
      var count = parseInt(m[1], 10);
      var size = toNum(m[2]) * unitFactor(m[3]);
      if (count > 0 && isFinite(size)) return count * size;
    }
    m = str.match(SINGLE_RE);
    if (m) {
      var v = toNum(m[1]) * unitFactor(m[2]);
      if (isFinite(v)) return v;
    }
    /* Fallback: reine Zahl (z. B. Stückzahlen "2er Set") */
    m = str.match(/(\d+(?:[.,]\d+)?)/);
    if (m) {
      var n = toNum(m[1]);
      if (isFinite(n)) return n;
    }
    return null;
  }

  function variantTitle(v) {
    return v ? (v.public_title || v.title || '') : '';
  }

  /* Preis robust in Cents (Shopify liefert je nach API Cents oder "12.90") */
  function toCents(price) {
    if (price == null) return 0;
    if (typeof price === 'string') {
      var f = parseFloat(price);
      if (!isFinite(f)) return 0;
      return price.indexOf('.') >= 0 || price.indexOf(',') >= 0 ? Math.round(f * 100) : f;
    }
    return price;
  }

  /* Vergleich: Größe aufsteigend → Preis aufsteigend → Originalreihenfolge */
  function compareVariants(a, b) {
    var sa = parseSize(variantTitle(a));
    var sb = parseSize(variantTitle(b));
    if (sa != null && sb != null && sa !== sb) return sa - sb;
    if (sa != null && sb == null) return -1;
    if (sa == null && sb != null) return 1;
    var pa = toCents(a.price);
    var pb = toCents(b.price);
    if (pa !== pb) return pa - pb;
    return 0;
  }

  /* Stabil sortierte Kopie */
  function sortVariants(variants) {
    if (!variants || !variants.length) return [];
    return variants
      .map(function (v, i) { return { v: v, i: i }; })
      .sort(function (a, b) {
        var c = compareVariants(a.v, b.v);
        return c !== 0 ? c : a.i - b.i;
      })
      .map(function (x) { return x.v; });
  }

  function isAvailable(v) {
    return v && v.available !== false && v.id;
  }

  /* Kleinste verfügbare Variante, sonst kleinste insgesamt */
  function smallestAvailable(variants) {
    var sorted = sortVariants(variants);
    for (var i = 0; i < sorted.length; i++) {
      if (isAvailable(sorted[i])) return sorted[i];
    }
    return sorted[0] || null;
  }

  function defaultFormatMoney(cents) {
    return (cents / 100).toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' €';
  }

  /* Kompaktes Auswahl-Dropdown für Upsell-Kacheln.
     opts: { formatMoney, className, selectedId, showPrice } */
  function buildSelect(variants, opts) {
    opts = opts || {};
    var fmt = opts.formatMoney || defaultFormatMoney;
    var sorted = sortVariants(variants);
    var preselect = opts.selectedId || (smallestAvailable(variants) || {}).id;

    var sel = document.createElement('select');
    sel.className = opts.className || 'bkv-select';
    sel.setAttribute('data-bkv-select', '');
    sorted.forEach(function (v) {
      var opt = document.createElement('option');
      opt.value = String(v.id);
      var label = variantTitle(v) || 'Standard';
      if (opts.showPrice !== false) label += ' – ' + fmt(toCents(v.price));
      if (!isAvailable(v)) {
        label += ' (ausverkauft)';
        opt.disabled = true;
      }
      opt.textContent = label;
      opt.setAttribute('data-price', String(toCents(v.price)));
      if (String(v.id) === String(preselect)) opt.selected = true;
      sel.appendChild(opt);
    });
    /* Klick im Dropdown darf umliegende Labels/Links nicht auslösen */
    ['click', 'mousedown', 'touchstart'].forEach(function (evt) {
      sel.addEventListener(evt, function (e) { e.stopPropagation(); });
    });
    return sel;
  }

  /* Sortiert <option>-Elemente eines bestehenden <select> numerisch */
  function sortSelectOptions(sel) {
    if (!sel) return;
    var opts = Array.prototype.slice.call(sel.options);
    var current = sel.value;
    opts
      .map(function (o, i) { return { o: o, i: i, s: parseSize(o.getAttribute('data-title') || o.textContent) }; })
      .sort(function (a, b) {
        if (a.s != null && b.s != null && a.s !== b.s) return a.s - b.s;
        if (a.s != null && b.s == null) return -1;
        if (a.s == null && b.s != null) return 1;
        return a.i - b.i;
      })
      .forEach(function (x) { sel.appendChild(x.o); });
    sel.value = current;
  }

  /* Mengen-artige Optionsnamen (analog Liquid-Ausnahmeliste im Theme) */
  var SIZE_OPTION_RE = /^(menge|größe|groesse|size|gebinde|inhalt|füllmenge|fuellmenge)$/i;

  /* Sortiert die Pills im PDP-Variant-Picker (Datenblatt-Template).
     Reine DOM-Umsortierung — die Picker-Logik matcht über data-option-value
     und bleibt unberührt. */
  function sortPillGroups(root) {
    var scope = root || document;
    var groups = scope.querySelectorAll('.pdp-variant-picker__group');
    Array.prototype.forEach.call(groups, function (group) {
      var labelEl = group.querySelector('.pdp-variant-picker__label');
      var optionName = labelEl ? (labelEl.textContent.split(':')[0] || '').trim() : '';
      var container = group.querySelector('.pdp-variant-picker__options');
      if (!container) return;
      var btns = Array.prototype.slice.call(container.querySelectorAll('[data-option-value]'));
      if (btns.length < 2) return;

      var parsed = btns.map(function (btn, i) {
        return { btn: btn, i: i, s: parseSize(btn.getAttribute('data-option-value')) };
      });
      var parseableCount = parsed.filter(function (x) { return x.s != null; }).length;
      /* Nur mengenartige Optionen sortieren — Farbtöne (RAL-Nummern!)
         bleiben grundsätzlich unangetastet. */
      if (!SIZE_OPTION_RE.test(optionName)) return;
      if (parseableCount === 0) return;

      parsed
        .sort(function (a, b) {
          if (a.s != null && b.s != null && a.s !== b.s) return a.s - b.s;
          if (a.s != null && b.s == null) return -1;
          if (a.s == null && b.s != null) return 1;
          return a.i - b.i;
        })
        .forEach(function (x) { container.appendChild(x.btn); });
    });
  }

  window.BekateqVariants = {
    parseSize: parseSize,
    toCents: toCents,
    compareVariants: compareVariants,
    sortVariants: sortVariants,
    smallestAvailable: smallestAvailable,
    buildSelect: buildSelect,
    sortSelectOptions: sortSelectOptions,
    sortPillGroups: sortPillGroups
  };

  /* PDP-Pills automatisch sortieren, sobald das DOM steht */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sortPillGroups(); });
  } else {
    sortPillGroups();
  }
})();
